export default __webpack_public_path__ + "static/seal-d8245d69bc255156daddc046f302bb06.svg";